import styles from "./styles.module.css";

type SliderProps = {
  size: number;
  currentStep?: number;
  totalSteps?: number;
};

const Slider = ({ size, currentStep, totalSteps }: SliderProps) => {
  const safeSize = Math.max(0, Math.min(100, size));

  return (
    <div className={styles.wrapper}>
      {typeof currentStep === "number" && typeof totalSteps === "number" && (
        <div className={styles.meta}>
          <span className={styles.stepText}>
            Question {currentStep} of {totalSteps}
          </span>
          <span className={styles.percentChip}>{Math.round(safeSize)}%</span>
        </div>
      )}

      <div
        className={styles.slider}
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={Math.round(safeSize)}
        aria-label="Assessment progress"
      >
        <div className={styles.track}>
          <div className={styles.indicator} style={{ width: `${safeSize}%` }} />
        </div>
      </div>
    </div>
  );
};

export default Slider;
